import React from 'react'
import {
    List,
    Edit,
    DateField,
    ReferenceField,
    BooleanField,
    SimpleForm,
    TextInput,
    Datagrid,
    TextField,
    BooleanInput,
    Show,
    NumberField,
    EmailField,
} from 'react-admin'

export const cartCartEdit = ({ ...props }) => (
    <Show {...props}>
        <SimpleForm>
            <TextField source="id" />
        </SimpleForm>
    </Show>
)

export const cartCartList = (props: any) => {
    return (
        <List {...props}>
            <Datagrid rowClick="edit">
                <TextField source="id" />
                <DateField source="created" />
                <DateField source="updated" />
                <ReferenceField source="userId" reference="user/user">
                    <TextField source="id" />
                </ReferenceField>
                <EmailField source="email" />
            </Datagrid>
        </List>
    )
}
